// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PrepaidCardProfilesEditController = function ($scope, $location, $routeParams, PrepaidCardProfile, TaxDefinition) {
    $scope.isCreate = false;
    $scope.isEdit = false;
    if ($routeParams.profileId != null) {
        $scope.profile = PrepaidCardProfile.get({ Id: $routeParams.profileId }, function (Data) { });
        $scope.isEdit = true;
    }
    else {
        $scope.profile = {};
        $scope.isCreate = true;
    }

    $scope.taxDefinitions = TaxDefinition.query();

    $scope.isUntaxed = function (profile) {
        if (!profile.Tax || !profile.Tax.TaxDefinitionId) {
            return false;
        }
        if ($scope.taxDefinitions.find(function (item) { return item.Id === profile.Tax.TaxDefinitionId}).PrimaryCategory === "Untaxed") {
            if (profile.Tax) {
                profile.Tax.Rate = 0;
            }
            return true;
        } else {
            return false;
        }
    }

    $scope.updateTaxDefinition = function (profile) {
        $scope.isUntaxed(profile);
    };

    $scope.save = function () {
        if ($routeParams.profileId != null) {
            $scope.profile.$update({Id: $routeParams.profileId}, function () {
                $location.path("settings/prepaid-card-profiles-list/Epay");
            });
        }
        else {
            PrepaidCardProfile.save($scope.profile, function () {
                $location.path("settings/prepaid-card-profiles-list/Epay");
            });
        }
    };
};
PrepaidCardProfilesEditController.$inject = ["$scope", '$location', '$routeParams', 'PrepaidCardProfile', 'TaxDefinition'];
